<template>
    <div class="row">
        <!--Modal profile user-->
        <modal v-if="tableData.length > 0" :show.sync="viewUser" headerClasses="justify-content-center">
            <div class="card card-user">
                <div class="image">
                <img :src="profile_background" alt="...">
                </div>
                <div class="card-body">
                <div class="author">
                    <img class="avatar border-gray" :src="profile_user" alt="...">
                    <h5 class="title">{{tableData[userIndex].name}} {{tableData[userIndex].surname}}</h5>
                    <p class="description">
                    @{{tableData[userIndex].username}}
                    </p>
                    <p class="description">
                    Correo: {{tableData[userIndex].email}}
                    </p>
                    <p class="description">
                    Rol: {{tableData[userIndex].group_name}}
                    </p>
                    <p v-if="tableData[userIndex].regional_name" class="description">
                    Regional: {{tableData[userIndex].regional_name}}
                    </p>
                    <p v-if="tableData[userIndex].office_name" class="description">
                    Oficina: {{tableData[userIndex].office_name}}
                    </p>
                    <p v-if="tableData[userIndex].analyst_type_name" class="description">
                    Tipo de analista: {{tableData[userIndex].analyst_type_name}}
                    </p>

                </div>
                </div>
                <div class="card-footer">
                <hr>
                <div class="button-container">
                    <div class="row">
                    <div class="col-lg-12 col-md-12 col-12 ml-auto">
                        <h5>
                        <small>Banco Mundo Mujer S.A</small>
                        </h5>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <template slot="footer">
                <p-button type="default" link @click="viewUser = false">Cerrar</p-button>
            </template>
        </modal>
        <!-- ./Modal profile user-->
        <!--Title-->
        <div class="text-right col-md-12">
                <p-button 
                    v-if="tableData && tableData.length && !this.$apollo.queries.users.loading"
                    @click="handleAdd" 
                    type="warning" 
                    outline>Agregar usuario
                    <i class="ml-2 fa fa-plus"></i>
                </p-button>
                <h4 class="title center-title pull-left">Usuarios</h4>
        </div>
        <!--./Title-->
        <!--Loading state-->
        <loading :active.sync="this.$apollo.queries.users.loading"
        :can-cancel="false" 
        :is-full-page="fullPage">
        </loading>
        <!--./Loading state-->
        <!--Sending state-->
        <loading :active.sync="isSending"
        :can-cancel="false" 
        :is-full-page="fullPage">
        </loading>
        <!--./Sending state-->
        <!--Empty state-->
        <div v-if="tableData && !tableData.length && !this.$apollo.queries.users.loading" class="mt-3 col-md-12 card">
        <div class="card-header">
        </div>
        <div class="card-body">
            <img class="no_data_center"  v-bind:src="no_data_image" alt="">
        </div>
        <div class="card-footer text-center">
            <p-button 
                @click="handleAdd" 
                type="warning" 
                outline>Agregar usuario
                <i class="ml-2 fa fa-plus"></i>
            </p-button>            
        </div>
        </div>
        <!--./Empty state-->
        <!--usuarios data-->
        <div v-if="tableData &&  tableData.length && !this.$apollo.queries.users.loading" class="col-md-12 card">
        <div class="card-header">
            <div class="category">Lista de usuarios</div>
        </div>
        <div class="card-body row">
            <div class="col-sm-4">
                <div>
                    <fg-input class="input-sm"
                            placeholder="Buscar"
                            v-model="searchQuery"
                            addon-right-icon="nc-icon nc-zoom-split">
                    </fg-input>
                </div>
            </div>
            <div class="col-sm-12 mt-2">
            <el-table class="table-striped"
                        :data="queriedData"
                        border
                        style="width: 100%">
                <el-table-column v-for="column in tableColumns"
                                :key="column.label"
                                :min-width="column.minWidth"
                                :prop="column.prop"
                                :label="column.label">
                </el-table-column>
                <el-table-column
                :min-width="200"
                fixed="right"
                class-name="td-actions"
                label="Acciones">
                <template slot-scope="props">
                    <el-tooltip content="Visualizar usuario" placement="left">
                        <p-button type="warning" size="sm" icon @click="handleView(props.$index, props.row)">
                            <i class="fa fa-eye"></i>
                        </p-button>
                    </el-tooltip>
                    <el-tooltip content="Editar información" placement="bottom">
                        <p-button type="primary" size="sm" icon @click="handleEdit(props.$index, props.row)">
                            <i class="fa fa-edit"></i>
                        </p-button>
                    </el-tooltip>
                    <el-tooltip content="Editar contraseña" placement="bottom">
                        <p-button type="success" size="sm" icon @click="handleEditPassword(props.$index, props.row)">
                            <i class="fa fa-lock"></i>
                        </p-button>
                    </el-tooltip>
                    <el-tooltip v-show="props.row.isActive" content="Desactivar" placement="bottom">
                    <p-button type="danger" size="sm" icon @click="handleDeactivate(props.$index, props.row)">
                        <i class="fa fa-pause"></i>
                    </p-button>
                    </el-tooltip>
                    <el-tooltip  v-show="!props.row.isActive" content="Activar" placement="bottom">
                    <p-button type="success" size="sm" icon @click="handleActivate(props.$index, props.row)">
                        <i class="fa fa-play"></i>
                    </p-button>
                    </el-tooltip>
                </template>
                </el-table-column>
            </el-table>
            </div>
            <div class="col-sm-6 pagination-info">
            <p class="category">Mostrando {{from + 1}} a {{to}} de {{total}} registros</p>
            </div>
            <div class="col-sm-12 mt-2">
                <el-select
                    class="select-default pull-left"
                    v-model="pagination.perPage"
                    placeholder="Per page">
                    <el-option
                    class="select-default"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
                <p-pagination class="pull-right"
                                v-model="pagination.currentPage"
                                :per-page="pagination.perPage"
                                :total="pagination.total">
                </p-pagination>
            </div>
        </div>
        </div>
        <!--./usuarios data-->
        <!--Add usuarios form-->
        <div v-if="(addUser == true || editUser == true || editUserPassword == true) && !this.$apollo.queries.users.loading" class="col-md-12 card">
            <form>
                <div class="card-header">
                    <h4 class="card-title">
                    {{formName}}
                    </h4>
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <label>Nombre</label>
                        <fg-input   :disabled="editUserPassword"
                                    ref="name"
                                    type="text"
                                    name="nombre"
                                    autocomplete="off"
                                    v-validate="modelValidations.name"
                                    :error="getError('nombre')"
                                    v-model="model.name">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Apellido</label>
                        <fg-input   :disabled="editUserPassword"
                                    ref="surname"
                                    type="text"
                                    name="apellido"
                                    autocomplete="off"
                                    v-validate="modelValidations.surname"
                                    :error="getError('apellido')"
                                    v-model="model.surname">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Nombre de usuario</label>
                        <fg-input   :disabled="validateUsername()"
                                    type="text"
                                    name="nombre de usuario"
                                    autocomplete="off"
                                    v-validate="this.addUser ? modelValidations.username : ''"
                                    :error="getError('nombre de usuario')"
                                    v-model="model.username">
                        </fg-input>
                    </div>
                    <div v-if="addUser || editUserPassword" class="form-group">
                        <label>Contraseña</label>
                        <fg-input   ref="password"
                                    type="password"
                                    name="contraseña"
                                    autocomplete="off"
                                    v-validate="modelValidations.password"
                                    :error="getError('contraseña')"
                                    v-model="model.password">
                        </fg-input>
                    </div>
                    <div v-if="addUser || editUserPassword" class="form-group">
                        <label>Confirmar contraseña</label>
                        <fg-input   v-model="model.confirmPassword"
                                    name="confirmar contraseña"
                                    autocomplete="off"
                                    v-validate="modelValidations.confirmPassword"
                                    :error="getError('confirmar contraseña')"
                                    type="password">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Correo electrónico de usuario</label>
                        <fg-input   :disabled="editUserPassword"
                                    type="text"
                                    name="correo"
                                    autocomplete="off"
                                    v-validate="modelValidations.email"
                                    :error="getError('correo')"
                                    v-model="model.email">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Rol</label>
                        <fg-input   name="rol"
                                    v-validate="modelValidations.group"
                                    :error="getError('rol')"
                                    v-model="model.group">
                                <el-select @change="reviewGroups()"
                                        :disabled="editUserPassword"
                                        class="select-warning"
                                        size="large"
                                        placeholder="Seleccione el rol..."
                                        v-model="model.group">
                                <el-option v-for="option in groups_array"
                                        class="select-warning"
                                        :value="option.id"
                                        :label="option.name"
                                        :key="option.id">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                    <div v-if="regionalView" class="form-group">
                        <label>Regional</label>
                        <fg-input   name="regional"
                                    v-validate="modelValidations.regional"
                                    :error="getError('regional')"
                                    v-model="model.regional">
                                <el-select :disabled="editUserPassword"
                                        class="select-warning"
                                        size="large"
                                        placeholder="Seleccione la regional..."
                                        v-model="model.regional">
                                <el-option v-for="option in regionals_array"
                                        class="select-warning"
                                        :value="option.id"
                                        :label="option.name"
                                        :key="option.id">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                    <div v-if="agencyView && model.regional != ''" class="form-group">
                        <label>Agencia</label>
                        <fg-input   name="agencia"
                                    v-validate="modelValidations.agency"
                                    :error="getError('agencia')"
                                    v-model="model.agency">
                                <el-select 
                                        class="select-warning"
                                        size="large"
                                        placeholder="Seleccione la agencia..."
                                        v-model="model.agency">
                                <el-option v-for="option in offices_array_computed"
                                        class="select-warning"
                                        :value="option.id"
                                        :label="option.name"
                                        :key="option.id">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                    <div v-if="analystTypeView" class="form-group">
                        <label>Tipo de analista</label>
                        <fg-input   name="tipo de analista"
                                    v-validate="modelValidations.analyst_type"
                                    :error="getError('tipo de analista')"
                                    v-model="model.analyst_type">
                                <el-select 
                                        class="select-warning"
                                        size="large"
                                        placeholder="Seleccione el tipo de analista..."
                                        v-model="model.analyst_type">
                                <el-option v-for="option in analystTypes_array"
                                        class="select-warning"
                                        :value="option.id"
                                        :label="option.name"
                                        :key="option.id">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Tipo de autenticación</label>
                        <fg-input   name="autenticación"
                                    v-validate="modelValidations.auth_system"
                                    :error="getError('autenticación')"
                                    v-model="model.auth_system">
                                <el-select :disabled="editUserPassword"
                                        class="select-warning"
                                        size="large"
                                        placeholder="Seleccione método de autenticación..."
                                        v-model="model.auth_system">
                                <el-option 
                                        class="select-warning"
                                        value="django.contrib.auth.backends.ModelBackend"
                                        label="Local">
                                </el-option>
                                <el-option 
                                        :disabled="true"
                                        class="select-warning"
                                        value="auth.backends.ActiveDirectoryAuthBackend"
                                        label="Directorio activo">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                        <p-button v-if="!viewUser" type="success" @click.prevent="validate">Aceptar</p-button>
                        <p-button type="default" class="pull-left mb-3" @click="cancelForm">Cancelar</p-button>
                    </div>
                </div>
            </form>
        </div>
        <!--./Add usuario form-->
    </div>
    
</template>
    <script>
    import { Card, Button, Modal } from 'src/components/UIComponents'
    import swal from 'sweetalert2'
    import Vue from 'vue'
    import {Table, TableColumn, Select, Option} from 'element-ui'
    import PPagination from 'src/components/UIComponents/Pagination.vue'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { Tooltip } from 'element-ui'
    import gql from 'graphql-tag'
    import { users } from 'src/api/graphql/queries/user/AllUsers';
    import { groups } from 'src/api/graphql/queries/group/AllGroups';
    import { CREATE_USER } from 'src/api/graphql/mutations/user/AddUser';
    import { EDIT_USER } from 'src/api/graphql/mutations/user/EditUser';
    import { PASSWORD_CHANGE } from 'src/api/graphql/mutations/user/PasswordChange';
    import { CREDIT_ANALYST } from 'src/api/graphql/mutations/user/CreditAnalyst';
    import { OFFICE_DIRECTOR } from 'src/api/graphql/mutations/user/OfficeDirector';
    import { REGIONAL_DIRECTOR } from 'src/api/graphql/mutations/user/RegionalDirector';
    import { regionals } from 'src/api/graphql/queries/setup/AllRegionals';
    import { offices } from 'src/api/graphql/queries/setup/AllOffices';
    import { analystTypes } from 'src/api/graphql/queries/setup/AllAnalystTypes';
    import { orderBy , sortBy , find } from 'lodash';
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    export default{
        /***
        * Esta es la función para hacer todos los llamados de GraphQL al servidor mediante VueApollo
        *
        **/
        apollo:{
            users:    {
                    query: users,
                    skip: false,
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        if(data.users.edges.length == 0)
                        {
                            this.users = [];
                        }
                        else
                        {
                            this.setUsers(data.users);
                            this.$apollo.queries.users.skip = true;
                        }
                        
                    },
                    // Si encontró algún error.
                    error(error) {
                        
                    },
                },
            groups: {
                    query: groups,
                    skip: false,
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        
                        if(data.groups.edges.length == 0)
                        {
                            this.groups_array = [];
                        }
                        else
                        {
                            this.setGroups(data.groups);
                            this.$apollo.queries.groups.skip = true;
                        }
                        
                    },
                    // Si encontró algún error.
                    error(error) {
                        
                    },
                },
            analystTypes: {
                    query: analystTypes,
                    skip: false,
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        
                        if(data.analystTypes.edges.length == 0)
                        {
                            this.analystTypes_array = [];
                        }
                        else
                        {
                            this.setAnalystTypes(data.analystTypes);
                            this.$apollo.queries.analystTypes.skip = true;
                        }
                        
                    },
                    // Si encontró algún error.
                    error(error) {
                        
                    },
                },
            offices:    {
                    query: offices,
                    variables:{
                        isActive: true
                    },
                    skip: false,
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        
                        if(data.offices.edges.length == 0)
                        {
                            this.offices = [];
                        }
                        else
                        {
                            this.setOffices(data.offices);
                            this.$apollo.queries.offices.skip = true;
                        }
                        
                    },
                    // Si encontró algún error.
                    error(error) {
                        
                    },
                },
            regionals: {
                    query: regionals,
                    skip: false,
                    variables: {
                        isActive: true
                    },
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        
                        if(data.regionals.edges.length == 0)
                        {
                            this.regionals_array = [];
                        }
                        else
                        {
                            this.setRegionals(data.regionals);
                            this.$apollo.queries.regionals.skip = true;
                        }
                        
                    },
                    // Si encontró algún error.
                    error(error) {
                        
                    },
                },
        },
        components: {
        Card,
        Modal,
        PPagination,
        Loading,
        [Tooltip.name]: Tooltip
        },
        computed: {
        offices_array_computed(){
            return this.offices_array.filter(i => i.regional == this.model.regional)
        },
        pagedData () {
            return this.tableData.slice(this.from, this.to)
        },
        /***
         * Searches through table data and returns a paginated array.
         * Note that this should not be used for table with a lot of data as it might be slow!
         * Do the search and the pagination on the server and display the data retrieved from server instead.
         * @returns {computed.pagedData}
         */
        queriedData () {
            if (!this.searchQuery) {
            this.pagination.total = this.tableData.length
            return this.pagedData
            }
            let result = this.tableData
            .filter((row) => {
                let isIncluded = false
                for (let key of this.propsToSearch) {
                let rowValue = row[key].toString().toLowerCase();
                if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
                    isIncluded = true
                }
                }
                return isIncluded
            })
            this.pagination.total = result.length
            return result.slice(this.from, this.to)
        },
        to () {
            let highBound = this.from + this.pagination.perPage
            if (this.total < highBound) {
            highBound = this.total
            }
            return highBound
        },
        from () {
            return this.pagination.perPage * (this.pagination.currentPage - 1)
        },
        total () {
            this.pagination.total = this.tableData.length
            return this.tableData.length
        }
        },
        data () {
        return {
            no_data_image : process.env.VUE_APP_BASE_ROUTE+'img/no_data.png',
            profile_background : process.env.VUE_APP_BASE_ROUTE+'img/login_background.jpg',
            profile_user : process.env.VUE_APP_BASE_ROUTE+'img/user@2x.png',
            analystSelected : false,
            agencyDirectorSelected : false,
            regionalDirectorSelected : false,
            agencyView: false,
            analystTypeView: false,
            regionalView: false,
            isSending: false,
            fullPage: false,
            usernames:[],
            tableData: [],
            groups_array: [],
            regionals_array: [],
            offices_array : [],
            analystTypes_array : [],
            userIndex: 0,
            addUser : false,//Bandera de creación de usuarios
            editUser : false,//Bandera de edición de usuarios
            editUserPassword : false,//Bandera de edición de contraseña de usuario
            viewUser : false,//Bandera de visualización de usuarios
            rowEdit: {},
            formName: 'Cargando...',//Nombre del formulario de creación/edición
            model: {
                id: '',
                name: '',
                surname: '',
                username: '',
                password: '',
                confirmPassword: '',
                auth_system: '',
                email: '',
                group: '',
                agency: '',
                analyst_type:'',
                regional:'',
                group_name: '',
                group_id: '',
                regional_id:'',
                regional_name:'',
                office_id:'',
                office_name:'',
                analyst_type_id:'',
                analyst_type_name:'',
                isActive: true
            },
            modelValidations: {
            name: {
                required: true,
                max: 32
            },
            surname: {
                required: true,
                max: 32
            },
            username: {
                alpha_dash: true,
                required: true,
                unique: true,
                max: 32
            },
            password: {
                required: true,
                min: 8
            },
            confirmPassword: {
                required: true,
                confirmed: 'password'
            },
            email: {
                email: true,
                required: true,
                max: 64
            },
            auth_system: {
                required: true,
            },
            group: {
                required: true,
            },
            regional: {
                required: true,
            },
            agency: {
                required: true,
            },
            analyst_type: {
                required: true,
            },
            },
            pagination: {
                perPage: 5,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0
            },
            searchQuery: '',
            propsToSearch: ['name','email','group'],
            tableColumns: [
            
            {
                prop: 'username',
                label: 'Nombre Usuario',
                minWidth: 250
            },
            {
                prop: 'email',
                label: 'Correo',
                minWidth: 250
            },
            {
                prop: 'group',
                label: 'Rol',
                minWidth: 250
            },
            ],
        }
        },
        methods: {
            /***
             * Función para setear en la tabla los datos que llegan desde la Regional
             */
            setRegionals(regionals){
                var vm = this;
                for(let i=0;i<regionals.edges.length;i++)
                {
                    vm.pushRegionalsData(regionals.edges[i].node);
                }
                vm.orderRegionalsData();
            },
            /***
             * Función para setear en la tabla los datos que llegan desde la oficina
             */
            setOffices(offices){
                var vm = this;
                for(let i=0;i<offices.edges.length;i++)
                {
                    vm.pushOfficesData(offices.edges[i].node);
                }
                vm.orderOfficesData();  
            },
            /***
            * Función para setear en la tabla los datos que llegan desde la Regional
            */
            setAnalystTypes(analystTypes){
            var vm = this;
            for(let i=0;i<analystTypes.edges.length;i++)
            {
                vm.pushAnalystTypesData(analystTypes.edges[i].node);
            }
            vm.orderAnalystTypesData();  
            },
            /***
            * Función para validar si requiere un campo adicional de analista, director o regional
            */
            reviewGroups(){
                var vm = this;
                vm.analystSelected = false;
                vm.agencyDirectorSelected = false;
                vm.regionalDirectorSelected = false;
                vm.agencyView = false;
                vm.analystTypeView = false;
                vm.regionalView = false;
                let selectGroup = vm.groups_array.find((data) => data.id === vm.model.group)
                if(selectGroup.name == "Analista"){
                    vm.analystSelected = true;
                    vm.regionalView = true;
                    vm.agencyView = true;
                    vm.analystTypeView = true;
                }
                else if(selectGroup.name == "Director"){
                    vm.agencyDirectorSelected = true;
                    vm.regionalView = true;
                    vm.agencyView = true;
                }
                else if(selectGroup.name == "Director regional"){
                    vm.regionalDirectorSelected = true;
                    vm.regionalView = true;
                }
            },
            /***
             * Función para validar si puedo editar el username
             */
            validateUsername(){
                var vm = this;
                if(vm.addUser == true)
                {
                    return false
                }
                else
                {
                    return true
                }
            },
            /***
             * Función para setear en la tabla los datos que llegan desde los grupos
             */
            setGroups(groups){
                var vm = this;
                for(let i=0;i<groups.edges.length;i++)
                {
                    vm.pushGroupsData(groups.edges[i].node);
                }
                vm.orderGroupsData();
            },
            /***
             * Función para setear en la tabla los datos que llegan desde el usuario
             */
            setUsers(users){
                var vm = this;
                for(let i=0;i<users.edges.length;i++)
                {
                    vm.pushData(users.edges[i].node);
                    vm.pushUsernames(users.edges[i].node);
                }
                vm.orderData();  
            },
            /*** 
            * Función que valida si se está enviando o cargando datos
            */
            handleLoading(){
            if(isLoading == true || isSending == true){
                return true
            }
            else{
                return false
            }
            },
            /*** 
            * Función que se dispara cuando se da clic en Agregar usuarios
            */
            handleAdd (){
                var vm = this;
                let promise = new Promise(function(resolve, reject) {
                    vm.resetForm();
                    vm.formName = 'Agregar usuario';
                    vm.setVisibleForm(true,false,false)//Asignamos las variables de visualización del formulario
                    vm.errors.clear();//Borramos las validaciones en los campos.
                    resolve();
                }).then(function(resolve){
                    vm.focusFirstField();
                });
                
            },
            /*** 
            * Función que se dispara cuando se da clic en Visualizar usuarios
            */
            handleView (index, row) {
                var vm = this;
                vm.userIndex = index;
                vm.viewUser = true;
            },
            /*** 
            * Función que se dispara cuando se da clic en Editar usuarios
            */
            handleEdit (index, row) {
                var vm = this;
                vm.rowEdit = row;
                let promise = new Promise(function(resolve, reject) {
                    vm.formName = 'Editar usuario';
                    vm.model.id = row.id;
                    vm.model.username = row.username;
                    vm.model.name = row.name;
                    vm.model.surname = row.surname;
                    vm.model.email = row.email;
                    vm.model.group = row.group_id;
                    vm.model.auth_system = row.auth_system;
                    vm.model.regional = row.regional_id ? row.regional_id : '';
                    vm.model.agency = row.office_id ? row.office_id : '';
                    vm.model.analyst_type = row.analyst_type_id ? row.analyst_type_id : '';
                    vm.setVisibleForm(false,true,false)//Asignamos las variables de visualización del formulario
                    vm.errors.clear();//Borramos las validaciones en los campos.
                    resolve();
                }).then(function(resolve){
                    vm.reviewGroups();
                    vm.focusFirstField();
                });
            },
            /*** 
            * Función que se dispara cuando se da clic en Editar usuarios
            */
            handleEditPassword (index, row) {
                var vm = this;
                vm.rowEdit = row;
                let promise = new Promise(function(resolve, reject) {
                    vm.formName = 'Editar contraseña de usuario';
                    vm.model.id = row.id;
                    vm.model.username = row.username;
                    vm.model.name = row.name;
                    vm.model.surname = row.surname;
                    vm.model.email = row.email;
                    vm.model.group = row.group_id;
                    vm.model.auth_system = row.auth_system;
                    vm.setVisibleForm(false,false,true)//Asignamos las variables de visualización del formulario
                    vm.errors.clear();//Borramos las validaciones en los campos.
                    resolve();
                }).then(function(resolve){
                    vm.focusFirstField();
                });
            },
            /*** 
            * Función que se dispara cuando se da clic en Desactivar usuarios
            */
            handleDeactivate (index, row) {
                var vm = this;
                swal({
                    title: '¿Estás seguro?',
                    text: 'Si aceptas, desactivarás el usuario seleccionado',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Si, desactivar',
                    cancelButtonText: 'No, cancelar',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    buttonsStyling: false
                }).then(() => {
                    let activateRow = this.tableData.find((tableRow) => tableRow.username === row.username)
                    this.isSending = true;
                    var id = vm.idDecode(activateRow.id);
                    var group_id = vm.idDecode(activateRow.group_id);
                    this.$apollo.mutate({
                        mutation: EDIT_USER,
                        variables : {
                            input :  {
                                    user: id,
                                    name: activateRow.name,
                                    surname: activateRow.surname,
                                    email: activateRow.email,
                                    authSystem: activateRow.auth_system,
                                    group: group_id,
                                    isActive: false
                                }
                        }
                    }).then((data) => {
                        let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id)
                        if (indexToDelete >= 0) {
                        this.tableData.splice(indexToDelete, 1)
                        }
                        this.pushData(data.data.userUpdate.user);
                        this.orderData();
                        this.isSending = false;
                        swal({
                        title: '¡Desactivado!',
                        text: 'El usuario seleccionado ha sido desactivado',
                        type: 'success',
                        confirmButtonClass: 'btn btn-success btn-fill',
                        buttonsStyling: false
                        }).then(() => {
                            vm.reloadData();
                        },function (dismiss){
                            vm.reloadData();
                        });
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.onError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                    });
                    
                }, function (dismiss) {
                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                    swal({
                        title: 'Cancelado',
                        text: 'El usuario no ha sido desactivado',
                        type: 'error',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        buttonsStyling: false
                    })
                    })    
            },
            /*** 
            * Función que se dispara cuando se da clic en Activar usuarios
            */
            handleActivate (index, row) {
                var vm = this;
                swal({
                    title: '¿Estás seguro?',
                    text: 'Si aceptas, activarás el usuario seleccionado',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Si, activar',
                    cancelButtonText: 'No, cancelar',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    buttonsStyling: false
                }).then(() => {
                    let activateRow = this.tableData.find((tableRow) => tableRow.username === row.username)
                    this.isSending = true;
                    var id = vm.idDecode(activateRow.id);
                    var group_id = vm.idDecode(activateRow.group_id);
                    this.$apollo.mutate({
                        mutation: EDIT_USER,
                        variables : {
                            input :  {
                                    user: id,
                                    name: activateRow.name,
                                    surname: activateRow.surname,
                                    email: activateRow.email,
                                    authSystem: activateRow.auth_system,
                                    group: group_id,
                                    isActive: true
                                }
                        }
                    }).then((data) => {
                        let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id)
                        if (indexToDelete >= 0) {
                        this.tableData.splice(indexToDelete, 1)
                        }
                        this.pushData(data.data.userUpdate.user);
                        this.orderData();
                        this.isSending = false;
                        swal({
                        title: '¡Activado!',
                        text: 'El usuario seleccionado ha sido activado',
                        type: 'success',
                        confirmButtonClass: 'btn btn-success btn-fill',
                        buttonsStyling: false
                        }).then(() => {
                            vm.reloadData();
                        },function (dismiss){
                            vm.reloadData();
                        });
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.onError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                    });
                    
                }, function (dismiss) {
                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                    swal({
                        title: 'Cancelado',
                        text: 'El usuario no ha sido activado',
                        type: 'error',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        buttonsStyling: false
                    })
                    })    
            },
            /**
            * Función que pone el foco en el campo de code o name
            */
            focusFirstField(){
                var vm = this;
                if(vm.editUserPassword)
                {
                    this.$refs.password.$el.children[0].focus();//Asignamos focus en el campo
                }
                else
                {
                    this.$refs.name.$el.children[0].focus();//Asignamos focus en el campo
                }
                
            },
            /**
            * Función para asignar el true o false a las opciones de agregar y editar oficinaes
            */
            setVisibleForm(add,edit,editPassword)
            {
                this.addUser = add;
                this.editUser = edit;
                this.editUserPassword = editPassword;
            },
            /*** 
            * Función que resetea el formulario
            */
            resetForm(){
                this.model.id = '';
                this.model.name = '';
                this.model.surname = '';
                this.model.username = '';
                this.model.password = '';
                this.model.confirmPassword = '';
                this.model.email = '';
                this.model.group = '';
                this.model.auth_system = '';
            },
            /*** 
            * Función que cancela la creación/edición de usuarios y resetea los campos
            */
            cancelForm(){
                this.resetForm();
                this.addUser = false;
                this.editUser = false;
                this.errors.clear();
                window.scrollTo(0,0);
                // this.$router.go();
            },
            /*** 
            * Función que permite visualizar los errores en cada campo del input
            */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /*** 
            * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro exitoso
            */
            onSuccess(message){
                swal({
                    title: `¡Correcto!`,
                    text: message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    type: 'success'
                });
            },
            /*** 
            * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro erróneo
            */
            onError(message){
                swal({
                    title: `¡Alerta!`,
                    text: message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-danger btn-fill',
                    type: 'error'
                });
            },
            /*** 
            * Función que oculta el formulario de creación/edición una vez realizado un envío de datos al servidor
            */
            reloadData(){
                var vm = this;
                vm.resetForm();
                vm.setVisibleForm(false,false,false)//Asignamos las variables de visualización del formulario 
            },
            /***
            * Función para agregar un objeto al arreglo de usernames
            */
            pushUsernames (node){
                var vm = this;
                vm.usernames.push(node.username);
            },
            /***
            * Función para agregar un objeto al arreglo de datos
            */
            pushData(node){
                var vm = this;
                if(node.creditanalyst != null)
                {
                    vm.tableData.push({
                        id: node.id,
                        name: node.name,
                        surname: node.surname,
                        username: node.username,
                        group_name: node.group.name,
                        group: node.group.name,
                        group_id: node.group.id,
                        auth_system: node.authSystem,
                        email: node.email,
                        regional_id: node.creditanalyst.office.regional.id,
                        regional_name: node.creditanalyst.office.regional.name,
                        office_id: node.creditanalyst.office.id,
                        office_name: node.creditanalyst.office.name,
                        analyst_type_id: node.creditanalyst.analystType.id,
                        analyst_type_name: node.creditanalyst.analystType.name,
                        isActive: node.isActive,
                    });
                }
                else if(node.officedirector)
                {
                    vm.tableData.push({
                        id: node.id,
                        name: node.name,
                        surname: node.surname,
                        username: node.username,
                        group_name: node.group.name,
                        group: node.group.name,
                        group_id: node.group.id,
                        auth_system: node.authSystem,
                        email: node.email,
                        regional_id: node.officedirector.office.regional.id,
                        regional_name: node.officedirector.office.regional.name,
                        office_id: node.officedirector.office.id,
                        office_name: node.officedirector.office.name,
                        isActive: node.isActive,
                    });
                }
                else if(node.regionaldirector){
                    vm.tableData.push({
                        id: node.id,
                        name: node.name,
                        surname: node.surname,
                        username: node.username,
                        group_name: node.group.name,
                        group: node.group.name,
                        group_id: node.group.id,
                        auth_system: node.authSystem,
                        email: node.email,
                        regional_id: node.regionaldirector.regional.id,
                        regional_name: node.regionaldirector.regional.name,
                        isActive: node.isActive,
                    });
                }
                else{
                    vm.tableData.push({
                        id: node.id,
                        name: node.name,
                        surname: node.surname,
                        username: node.username,
                        group_name: node.group.name,
                        group: node.group.name,
                        group_id: node.group.id,
                        auth_system: node.authSystem,
                        email: node.email,
                        isActive: node.isActive,
                    });
                }
            },
            /***
            * Función para agregar un objeto al arreglo de datos de grupos
            */
            pushGroupsData(node){
                var vm = this;
                vm.groups_array.push({
                    id: node.id,
                    name: node.name
                });
            },
            /***
            * Función para agregar un objeto al arreglo de datos de regionales
            */
            pushRegionalsData(node){
                var vm = this;
                vm.regionals_array.push({
                    id: node.id,
                    code: node.code,
                    name: node.name
                });
            },
            /***
            * Función para agregar un objeto al arreglo de datos de oficinas
            */
            pushOfficesData(node){
                var vm = this;
                vm.offices_array.push({
                    id: node.id,
                    code: node.code,
                    name: node.name,
                    regional: node.regional.id
                });
            },
            /***
            * Función para agregar un objeto al arreglo de datos de tipos de analistas
            */
            pushAnalystTypesData(node){
                var vm = this;
                vm.analystTypes_array.push({
                    id: node.id,
                    name: node.name
                });
            },
            /***
            * Función para ordenar el arreglo de datos
            */
            orderData(){
                var vm = this;
                const myOrderedArray = _.sortBy(vm.tableData, o => o.username);
                vm.tableData = myOrderedArray;
            },
            /***
            * Función para ordenar el arreglo de datos de regionales
            */
            orderGroupsData(){
                var vm = this;
                const myOrderedArray = _.sortBy(vm.groups_array, o => o.name);
                vm.groups_array = myOrderedArray;
            },
            /***
            * Función para ordenar el arreglo de datos de regionales
            */
            orderRegionalsData(){
                var vm = this;
                const myOrderedArray = _.sortBy(vm.regionals_array, o => o.name);
                vm.regionals_array = myOrderedArray;
            },
            /***
            * Función para ordenar el arreglo de datos de regionales
            */
            orderOfficesData(){
                var vm = this;
                const myOrderedArray = _.sortBy(vm.offices_array, o => o.name);
                vm.offices_array = myOrderedArray;
            },
            /***
            * Función para ordenar el arreglo de datos de regionales
            */
            orderAnalystTypesData(){
                var vm = this;
                const myOrderedArray = _.sortBy(vm.analystTypes_array, o => o.name);
                vm.analystTypes_array = myOrderedArray;
            },
            /***
            * Función para decodificar el ID en base 64
            */
            idDecode(id){
                let id_decoded = atob(id);
                return id_decoded.split(":")[1];
            },
            /***
            * Función posterior al envío de la mutación de crear o editar información
            */
            postMutation(formMessage){
                var vm = this;
                if(!vm.addUser && vm.editUser)
                {
                    let indexToDelete = vm.tableData.findIndex((tableRow) => tableRow.id === vm.rowEdit.id)
                    if (indexToDelete >= 0) {
                    vm.tableData.splice(indexToDelete, 1)
                    }
                }
                vm.orderData();
                vm.isSending = false;
                vm.onSuccess(formMessage);
                vm.reloadData();
            },
            /***
             * Función para validar el formulario de edición y creación que se envía
             */
            validate () {
                this.$validator.validateAll().then(isValid => {
                if(isValid){
                    // this.$emit('on-submit', this.registerForm, isValid)
                    var vm = this;
                    var formInput = {};
                    var formMessage = ""; 
                    vm.isSending = true;
                    /*** 
                    * Función para ejecutar la mutación de creación
                    */
                    if(vm.addUser && !vm.editUser && !vm.editUserPassword)
                    {
                        var group_id = vm.idDecode(vm.model.group);
                        formInput = {
                                name: vm.model.name,
                                surname: vm.model.surname,
                                username: vm.model.username,
                                password: vm.model.password,
                                email: vm.model.email,
                                group: group_id,
                                authSystem: vm.model.auth_system,
                                isActive: true
                        };
                        formMessage = "Usuario registrado con éxito";
                        // Iniciamos el envío de la mutación
                        this.$apollo.mutate({
                            mutation: CREATE_USER,
                            variables : {
                                input : formInput
                            }
                        }).then((data) => {
                            if(vm.analystSelected){
                                this.$apollo.mutate({
                                    mutation: CREDIT_ANALYST,
                                    variables : {
                                        input : {
                                            user: vm.idDecode(data.data.userCreation.user.id),
                                            office: vm.idDecode(vm.model.agency),
                                            analystType: vm.idDecode(vm.model.analyst_type)
                                        }
                                    }
                                }).then((data) => {
                                    vm.pushData(data.data.creditAnalyst.creditAnalyst.user);
                                    vm.isSending = false;
                                    vm.postMutation(formMessage);
                                }).catch((error) => {
                                    vm.isSending = false;
                                    vm.onError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                                });
                            }
                            else if(vm.agencyDirectorSelected){
                                this.$apollo.mutate({
                                    mutation: OFFICE_DIRECTOR,
                                    variables : {
                                        input : {
                                            user: vm.idDecode(data.data.userCreation.user.id),
                                            office: vm.idDecode(vm.model.agency),
                                        }
                                    }
                                }).then((data) => {
                                    vm.pushData(data.data.officeDirector.officeDirector.user);
                                    vm.isSending = false;
                                    vm.postMutation(formMessage);
                                }).catch((error) => {
                                    vm.isSending = false;
                                    vm.onError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                                });
                            }
                            else if(vm.regionalDirectorSelected){
                                this.$apollo.mutate({
                                    mutation: REGIONAL_DIRECTOR,
                                    variables : {
                                        input : {
                                            user: vm.idDecode(data.data.userCreation.user.id),
                                            regional: vm.idDecode(vm.model.regional),
                                        }
                                    }
                                }).then((data) => {
                                    vm.pushData(data.data.regionalDirector.regionalDirector.user);
                                    vm.isSending = false;
                                    vm.postMutation(formMessage);
                                }).catch((error) => {
                                    vm.isSending = false;
                                    vm.onError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                                });
                            }
                            else{
                                vm.pushData(data.data.userCreation.user);
                            }
                            vm.isSending = false;
                            vm.postMutation(formMessage);
                        }).catch((error) => {
                            vm.isSending = false;
                            vm.onError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                        });
                    }
                    /*** 
                    * Función para ejecutar la mutación de edición de información
                    */
                    else if(!vm.addUser && vm.editUser && !vm.editUserPassword)
                    {
                        var id = vm.idDecode(vm.model.id);
                        var group_id = vm.idDecode(vm.model.group);
                        formInput = {
                                user: id,
                                name: vm.model.name,
                                surname: vm.model.surname,
                                email: vm.model.email,
                                group: group_id,
                                authSystem: vm.model.auth_system,
                                isActive: vm.model.isActive
                        };
                        formMessage = "Usuario editado con éxito";
                        // Iniciamos el envío de la mutación
                        this.$apollo.mutate({
                            mutation: EDIT_USER,
                            variables : {
                                input : formInput
                            }
                        }).then((data) => {
                            vm.pushData(data.data.userUpdate.user);
                            vm.postMutation(formMessage);
                        }).catch((error) => {
                            vm.isSending = false;
                            vm.onError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                        });
                    }
                    /*** 
                    * Función para ejecutar la mutación de edición de contraseña
                    */
                    else if(!vm.addUser && !vm.editUser && vm.editUserPassword)
                    {
                        var id = vm.idDecode(vm.model.id);
                        formInput = {
                                user: id,
                                newPassword: vm.model.password,
                        };
                        formMessage = "Contraseña editada con éxito";
                        // Iniciamos el envío de la mutación
                        this.$apollo.mutate({
                            mutation: PASSWORD_CHANGE,
                            variables : {
                                input : formInput
                            }
                        }).then((data) => {
                            vm.postMutation(formMessage);
                        }).catch((error) => {
                            vm.isSending = false;
                            vm.onError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                        });
                    }
                }
                })
        }
        },
        mounted() {
            // this.test();
            // alert(this.$window.csrf_token);
            this.$validator.extend('unique', {
                getMessage: field => 'El nombre de usuario ya está siendo usado',
                validate: value => new Promise((resolve, reject) => {
                        setTimeout(() => {
                            resolve({
                            valid: this.usernames.indexOf(value) === -1
                        }, 500);
                    });
                    })
                });
        }
    }
    </script>
    <style lang="scss">
    .el-table .td-actions{
    button.btn {
        margin-right: 5px;
    }
    }
    // Función para centrar la imagen del Empty State
    .no_data_center {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 70%;
    }
    // Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
</style>
